let serverLocation = 'http://localhost:8081';
let authLocation = 'http://localhost:8080/auth';
let STRIPE_KEY = "pk_test_51Pr2Ys2LKRMg6YsPPjJWDG8UShzmhUQMAYErE2i9rAen6MEzrsDlbUSNU30FYEw8AbnmsVpwk7E7Dz085fXjONUs00wElA4YDL";
const apiVersion = '/api/v1';

if (process.env.NODE_ENV === "production") {
    if (process.env.REACT_APP_STAGE === "staging") {
        serverLocation = 'https://staging.sarlit.com';
        authLocation = 'https://staging.sarlit.com/auth';
    } else if (process.env.REACT_APP_STAGE === "production") {
        serverLocation = 'https://production.sarlit.com';
        authLocation = 'https://production.sarlit.com/auth';
		STRIPE_KEY = "pk_live_51Pr2Ys2LKRMg6YsPNjQeBojgLsOunKZKKKt4wGomg7QUd7QMCMkJUFZqZpQpKxpR2SqMdHp4X1dS1MDag1m4Dtgc00XEkbaxHz";
    }
}


export const apiUri = serverLocation + apiVersion;

export const AUTH_URI = authLocation;

export const STRIPE_PUBLISH_KEY = STRIPE_KEY;



// WEBPACK FOOTER //
// ./src/config.js